import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import { Icon } from './Icon';

interface AccordionCustomProps {
  title: any;
  content: any;
  defaultExpanded: boolean;
}

export const AccordionCustom: React.FC<AccordionCustomProps> = ({
  title,
  content,
  defaultExpanded,
}) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div
      className={`mb-6 ${
        expanded ? '' : ''
      }`}
    >
      <Accordion
        id="accordion-custom"
        style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
        defaultExpanded={defaultExpanded}
        expanded={expanded === 'panel'}
        onChange={handleChange('panel')}
      >
        <div className="bgcolorf5f5f5 faq_hover rounded-md ">
        <AccordionSummary
          expandIcon={
            <Icon.ChevronDown
              className={`transform transition pr-2 ${
                defaultExpanded
                  ? '-rotate-90 ease-in duration-300'
                  : 'ease-in-out duration-500'
              }`}
            />
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ padding: 0 }}
        >
          {/* <h1
            className={`md:text-base text-gray-600 ${
              expanded ? 'text-bold' : ''
            }`}
          > */}
          {title}
          {/* </h1> */}
        </AccordionSummary>
        </div>
        <AccordionDetails
          className={`flex flex-col ${expanded ? 'bg-white' : 'bg-white'}`}
        >
          {/* <div className="whitespace-pre text-gray-600 text-sm transform mt-1 p-3"> */}
          {content}
          {/* </div> */}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
